// extracted by mini-css-extract-plugin
export var article = "SectionFeaturedArticles-module--article--0gx5t";
export var articles = "SectionFeaturedArticles-module--articles--DftNi";
export var mobileReadMore = "SectionFeaturedArticles-module--mobileReadMore--olWXe";
export var readMore = "SectionFeaturedArticles-module--readMore---cPp-";
export var section = "SectionFeaturedArticles-module--section--L9gve";
export var thumbnail = "SectionFeaturedArticles-module--thumbnail--MVxhn";
export var thumbnailTitleExcerpt = "SectionFeaturedArticles-module--thumbnailTitleExcerpt--8brWE";
export var titleExcerpt = "SectionFeaturedArticles-module--titleExcerpt--+pp9o";